import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">
<path d="M4160 7089 c-165 -15 -357 -93 -504 -203 -188 -142 -318 -343 -379
-586 -18 -75 -21 -115 -21 -335 0 -266 6 -320 51 -455 53 -159 121 -269 243
-391 112 -114 250 -202 390 -251 145 -50 151 -51 743 -55 l557 -4 0 185 0 186
-492 0 c-277 0 -524 5 -563 10 -216 32 -395 161 -495 360 -26 51 -60 163 -60
196 0 12 79 14 530 14 l530 0 0 185 0 185 -530 0 -530 0 0 28 c0 78 61 222
133 318 78 103 187 177 332 225 69 23 76 23 605 26 l535 4 3 184 2 185 -497
-1 c-274 -1 -536 -5 -583 -10z"/>
<path d="M5510 6345 l0 -755 233 0 233 0 41 -27 c23 -14 52 -45 64 -67 23 -40
24 -49 26 -336 2 -162 3 -308 3 -324 l0 -28 283 5 c340 6 396 16 587 111 281
140 478 396 545 711 14 67 16 123 13 350 -5 297 -12 344 -79 497 -145 333
-478 576 -834 608 -55 5 -328 9 -607 10 l-508 0 0 -755z"/>
<path d="M5510 4995 l0 -535 225 0 c148 0 233 4 249 12 14 6 35 30 46 53 19
39 20 61 20 473 0 464 -2 481 -51 516 -20 14 -57 16 -256 16 l-233 0 0 -535z"/>
<path d="M5014 4272 c-19 -3 -23 -16 -39 -126 l-19 -123 -48 30 c-40 25 -55
29 -95 25 -110 -11 -183 -102 -183 -227 0 -50 5 -73 25 -106 46 -79 145 -98
220 -41 l35 27 0 -26 c0 -25 1 -26 62 -23 l63 3 17 110 c10 61 29 184 43 275
14 91 28 172 31 182 4 13 -4 17 -43 20 -26 1 -57 2 -69 0z m-96 -318 c17 -12
22 -25 22 -63 0 -39 -5 -52 -29 -75 -52 -49 -132 -32 -144 31 -7 37 10 90 36
108 28 19 86 19 115 -1z"/>
<path d="M2996 4228 c-2 -7 -16 -92 -31 -188 -15 -96 -33 -213 -41 -259 -8
-46 -14 -88 -14 -92 0 -5 72 -9 159 -9 l159 0 6 28 c3 15 7 43 8 62 l3 35 -82
3 c-89 3 -88 3 -77 61 l7 31 78 0 c87 0 80 -7 94 83 l6 37 -82 0 c-79 0 -81 1
-75 23 3 12 6 32 6 44 0 21 5 22 87 25 96 3 91 -1 106 91 l6 37 -160 0 c-119
0 -161 -3 -163 -12z"/>
<path d="M5757 4173 c-3 -5 -8 -29 -11 -55 -7 -47 -8 -48 -42 -48 -27 0 -34
-4 -34 -19 0 -10 -3 -33 -6 -50 -6 -29 -5 -31 25 -31 37 0 36 8 11 -145 -11
-66 -20 -126 -20 -132 0 -9 20 -13 65 -13 75 0 67 -15 93 165 l17 120 35 5
c29 4 36 10 41 35 13 61 11 65 -25 65 -27 0 -33 4 -31 18 2 9 6 34 9 55 l5 37
-64 0 c-35 0 -66 -3 -68 -7z"/>
<path d="M3475 4069 c-76 -28 -135 -122 -135 -214 0 -67 17 -110 59 -150 28
-26 40 -30 91 -30 45 0 65 5 89 23 37 27 51 28 44 2 -5 -18 0 -20 59 -20 l65
0 17 113 c10 61 22 141 27 177 5 36 12 73 15 83 5 15 -2 17 -60 17 -61 0 -66
-2 -72 -25 l-6 -24 -34 26 c-40 30 -110 39 -159 22z m149 -120 c20 -16 26 -29
26 -60 0 -51 -13 -75 -50 -94 -43 -22 -68 -18 -102 15 -26 27 -29 35 -24 68 9
46 55 92 95 92 15 0 40 -9 55 -21z"/>
<path d="M3952 4065 c-52 -23 -82 -62 -82 -107 0 -58 13 -74 90 -113 50 -25
70 -41 70 -54 0 -36 -74 -38 -128 -5 -12 8 -26 12 -31 10 -14 -9 -43 -75 -37
-85 13 -20 119 -43 178 -38 96 9 148 55 148 133 0 44 -31 77 -105 110 -40 17
-55 29 -55 44 0 28 39 35 85 16 48 -21 48 -21 63 11 21 47 16 60 -35 77 -57
20 -117 20 -161 1z"/>
<path d="M5275 4061 c-85 -38 -129 -120 -122 -224 5 -76 21 -107 78 -145 42
-29 115 -26 159 7 36 26 40 26 40 1 0 -18 7 -20 65 -20 41 0 65 4 65 11 0 14
48 326 55 357 5 21 3 22 -59 22 -61 0 -64 -1 -70 -26 l-7 -27 -22 21 c-48 45
-116 53 -182 23z m170 -118 c20 -25 18 -94 -3 -119 -39 -48 -87 -56 -128 -20
-45 38 -34 128 20 155 30 15 95 6 111 -16z"/>
<path d="M6070 4060 c-81 -43 -119 -109 -120 -206 0 -76 30 -138 80 -166 45
-25 119 -20 160 11 36 26 40 26 40 1 0 -19 5 -21 62 -18 l61 3 28 170 c39 234
42 217 -33 213 -57 -3 -63 -5 -66 -25 -4 -26 -17 -30 -26 -8 -8 22 -68 45
-113 45 -21 -1 -54 -9 -73 -20z m165 -115 c42 -41 29 -116 -25 -148 -35 -21
-53 -21 -90 -2 -52 27 -50 123 4 160 32 23 83 19 111 -10z"/>
<path d="M6713 4064 c-17 -7 -34 -18 -38 -24 -12 -19 -33 -11 -28 10 5 18 0
20 -58 20 l-64 0 -29 -183 c-15 -100 -34 -220 -42 -266 -20 -119 -23 -111 50
-111 l64 0 10 63 c6 34 14 83 18 109 l6 48 29 -25 c82 -68 219 -30 271 75 34
67 33 182 -2 233 -43 63 -115 83 -187 51z m57 -124 c35 -35 18 -137 -25 -154
-34 -12 -92 -6 -108 12 -30 33 -26 99 8 136 31 33 94 37 125 6z"/>
<path d="M7115 4061 c-131 -59 -169 -255 -70 -351 33 -32 41 -35 95 -35 45 0
65 5 89 23 37 27 41 27 41 2 0 -18 7 -20 63 -20 l63 0 28 178 c15 97 30 185
32 195 5 15 -3 17 -60 17 -59 0 -66 -2 -66 -19 0 -27 -15 -34 -31 -14 -36 43
-119 54 -184 24z m170 -118 c8 -10 14 -36 15 -58 0 -53 -32 -94 -82 -102 -32
-5 -41 -1 -69 26 -27 28 -30 36 -24 68 8 44 23 69 50 82 29 15 94 6 110 -16z"/>
<path d="M4190 4063 c0 -5 23 -82 50 -172 28 -91 50 -173 50 -183 0 -11 -22
-56 -50 -102 -27 -46 -50 -86 -50 -90 0 -3 31 -6 68 -6 l68 0 22 43 c12 23 43
83 70 132 26 50 70 131 96 180 27 50 62 113 77 141 16 28 29 54 29 58 0 3 -32
6 -71 6 l-70 0 -54 -111 -53 -111 -10 49 c-6 26 -16 76 -22 111 l-13 62 -68 0
c-38 0 -69 -3 -69 -7z"/>
<path d="M7490 4062 c0 -4 23 -83 50 -174 28 -91 50 -173 50 -181 0 -9 -22
-53 -50 -99 -27 -46 -50 -86 -50 -90 0 -14 127 -9 138 5 5 6 33 57 62 112 30
55 91 169 137 254 46 84 83 160 83 167 0 10 -17 14 -65 14 l-66 0 -49 -102
c-28 -56 -50 -108 -51 -117 -1 -31 -16 23 -34 122 l-17 97 -69 0 c-38 0 -69
-4 -69 -8z"/>
</g>
</svg>

    </Box> 
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
